export interface IClassLocation {
  id: number;
  name: string;
  active: boolean;
}

export class ClassLocation implements IClassLocation {
  id: number;
  name: string;
  active: boolean;

  constructor(config: IClassLocation) {
    this.id = config.id;
    this.name = config.name;
    this.active = config.active;
  }
}
